<template>
  <div class="faf-sanoma-container polyglottTypewriter">
    
    <div class="sanoma-header">
      <div class="sanoma-id">
        SANOMA n:o <span class="handwritten-id">{{ report_info.mission_id || '1639' }}</span>
      </div>
      
      <div class="header-grid">
        <div class="grid-box col-3">
          <span class="tiny-label">Viestin laatu:</span>
          <div class="grid-content">LES 0115 8541</div>
        </div>
        <div class="grid-box col-6">
          <span class="tiny-label">Aika/Pvm:</span>
          <div class="grid-content">{{ decodeHTML(missionById(report_info.mission_id).hist_date).split(' ')[0] }}</div>
        </div>
        <div class="grid-box col-3">
          <span class="tiny-label">Kello:</span>
          <div class="grid-content">{{ decodeHTML(missionById(report_info.mission_id).hist_date).split(' ')[1] }}</div>
        </div>
      </div>
      
      <div class="header-grid no-top">
        <div class="grid-box col-12">
          <span class="tiny-label">Lähettäjä:</span>
          <div class="grid-content">
            {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.last_name) }} / 
            {{ reportUnit.hist_unit_name }}
          </div>
        </div>
      </div>
    </div>

    <div class="sanoma-body">
      <div class="typed-line">
        == {{ reportUnit.hist_unit_code }}
      </div>

      <div class="typed-line">
        KONE: {{ reportAsset.name }} {{ decodeHTML(report_info.markings) }}
      </div>

      <div class="typed-line">
        OHJAAJA: {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.first_name) }} '{{ report_info.callsign }}' {{ decodeHTML(report_info.last_name) }}
      </div>

      <div class="typed-line">
        TUKIKOHTA: {{ decodeHTML(report_info.base) }}
      </div>

      <div class="separator-line">--------------------------------------------------</div>

      <div class="mission-content">
        <div class="typed-line label-line">TEHTÄVÄN SUORITUS:</div>
        <TextWithImage 
          class="white-space-pre-line mission-text" 
          v-bind:original_text="decodeHTML(report_info.synopsis)">
        </TextWithImage>
      </div>
    </div>

    <div class="sanoma-footer clearfix">
      <div class="float-right signature-block">
        <div class="signature-text">
          == {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.last_name) }} ==
        </div>
        <ReportApprovalComp
          v-bind="{stampImage:'/assets/images/webpage_images/faf-stamp.png'}"
        ></ReportApprovalComp>
      </div>
    </div>

  </div>
</template>

<script>
  import stringConv from "../../resource/stringConverter"
  import statConv from "../../resource/statusConverter"
  import TextWithImage from "../basic_comp/TextWithImages"
  import ReportApprovalComp from "./ReportApprovalComp"
  import { mapState, mapGetters } from "vuex"

  export default {
    name: "ReportFAF",
    components: {
      TextWithImage,
      ReportApprovalComp
    },
    mixins: [
      stringConv,
      statConv
    ],
    props: {

    },
    mounted () {
    },
    data () {
      return {
      }
    },
    computed: {

      ...mapState("missionStore", {
        report_info: state => state.report,
        report_details: state => state.report_details,
        aerial_claims: state => state.aerial_claims,
        ground_claims: state => state.ground_claims
      }),

      ...mapGetters("missionStore", [
        "reportUnit",
        "reportAsset",
        "missionById"
      ])
    }
  }
</script>

<style scoped>
/* Full Width & Inherited Background */
.faf-sanoma-container {
  width: 100%;
  color: inherit;
  font-family: 'Courier New', Courier, monospace;
}

/* Header Grid Styling */
.sanoma-header {
  margin-bottom: 30px;
}

.sanoma-id {
  text-align: right;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 1.2rem;
}

.handwritten-id {
  font-family: 'Brush Script MT', cursive; /* To mimic the handwritten number in the scan */
  font-size: 1.5rem;
  padding-left: 10px;
}

.header-grid {
  display: flex;
  border: 1px solid currentColor;
}

.no-top { border-top: none; }

.grid-box {
  padding: 4px 8px;
  border-right: 1px solid currentColor;
  min-height: 40px;
}

.grid-box:last-child { border-right: none; }

.col-3 { width: 25%; }
.col-6 { width: 50%; }
.col-12 { width: 100%; }

.tiny-label {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
}

.grid-content {
  font-weight: bold;
  font-size: 1rem;
}

/* Body Styling */
.sanoma-body {
  line-height: 1.6;
}

.typed-line {
  margin-bottom: 8px;
  text-transform: uppercase; /* Most Finnish reports were typed in caps */
  letter-spacing: 1px;
}

.label-line {
  font-weight: bold;
  text-decoration: underline;
}

.mission-text {
  padding-left: 10px;
  display: block;
  margin-top: 10px;
}

.separator-line {
  margin: 20px 0;
  opacity: 0.5;
}

/* Signature */
.signature-block {
  margin-top: 40px;
  text-align: center;
}

.signature-text {
  font-weight: bold;
  border-bottom: 1px solid currentColor;
  margin-bottom: 10px;
  padding: 0 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/campaign/ReportFAF.vue